<template>
    <li class="mt-4">
        <span title="" class="dropdown-item item-tema ">
            Tema
            <div class="btn-group btn-group-sm bm-3 float-end" role="group" aria-label="Seleziona il tema grafico">
                <button v-for="(t, tk) in themes" :key="tk" type="button" 
                    :class="{'btn btn-secondary':true, 'active': t.key == theme}"
                    @click="onClickTheme(t.key)">
                    {{ t.label }}
                </button>
            </div>
        </span>
    </li>
</template>
<script>

import axios from "axios"

export default {
    props: {
    },
    data() {
        return {
            theme: 'auto',
            themes: [
                {
                    key: 'light',
                    label: 'Chiaro'
                }, 
                {
                    key: 'dark',
                    label: 'Scuro'
                },
                {
                    key: 'auto',
                    label: 'Auto'
                }
            ]
        }
    },
    mounted(){
        console.log(this.theme)
        this.setThemeToDocument(this.theme)
    },
    methods: {
        onClickTheme(theme){
            this.theme = theme;
            this.setThemeToDocument(theme);

            axios.post('/service/user/UserAction-theme', {theme: theme})
                .then(response => {
                    console.log(response.data);
                })
                .catch(error => {
                    console.log(error);
                });
        },
        setThemeToDocument(theme){
            let t = window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
            if (theme == 'auto') theme = t;
            
            window.document.documentElement.setAttribute('data-bs-theme', theme)
        }
    }
}

</script>